import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptRecorderService} from '@spout/global-web/data-access';

@Component({
  selector: 'spt-help-getting-started-collaboration-content',
  templateUrl: './help-getting-started-collaboration-content.component.html',
  styleUrls: ['./help-getting-started-collaboration-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpGettingStartedCollaborationContentComponent {
  constructor(private _recorder: SptRecorderService) {}
  refresh(): void {
    this._recorder.refreshAudioDeviceList().subscribe(() => {});
  }
}
